/* Field components that could be used in Formik.Field */
import TextField from './TextField/TextField';
import SwitchField from './SwitchField/SwitchField';
import CheckboxField from './CheckboxField/CheckboxField';
import SelectField from './SelectField/SelectField';
import TextAreaField from './TextAreaField/TextAreaField';

export { default as Modal } from './Modal/Modal';
export { default as Switch } from './Switch/Switch';
export { default as Tabs } from './Tabs/Tabs';
export { default as Select } from './Select/Select';
export { default as Columns } from './Columns/Columns';
export { default as Checkbox } from './Checkbox/Checkbox';
export { default as Button } from './Button/Button';
export { default as Icon } from './Icon/Icon';
export { default as Box } from './Box/Box';

export const Fields = {
  Text: TextField,
  Switch: SwitchField,
  Checkbox: CheckboxField,
  Select: SelectField,
  TextAreaField: TextAreaField,
};
